"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9225],{

/***/ 75805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ Instance; },
/* harmony export */   "k": function() { return /* binding */ Graph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51285);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88231);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(highcharts__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86781);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71222);
/* harmony import */ var highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94438);
/* harmony import */ var highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63125);
/* harmony import */ var highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85466);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89928);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62690);
/* harmony import */ var _components_loading_overlay_spinner__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(59967);
/* harmony import */ var _hocs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(81861);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5887);




















if (typeof (highcharts__WEBPACK_IMPORTED_MODULE_1___default()) === "object") {
    highcharts_highcharts_more__WEBPACK_IMPORTED_MODULE_3___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
    highcharts_modules_exporting__WEBPACK_IMPORTED_MODULE_5___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
    highcharts_modules_drilldown__WEBPACK_IMPORTED_MODULE_4___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
}
var styles = function(theme) {
    return {
        hideOverflow: {
            overflow: "hidden"
        },
        container: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            position: "relative"
        }, theme.breakpoints.down("sm"), {
            // Widen out the chart on small screens, so we can better see the data.
            marginLeft: theme.spacing(-3),
            marginRight: theme.spacing(-1.5)
        })
    };
};
var shouldUpdate = function(prevProps, nextProps, _prevState, _nextState) {
    var aggressivelyMinimizeRendering = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (prevProps.loading !== nextProps.loading) {
        return true;
    }
    if (prevProps.error !== nextProps.error) {
        return true;
    }
    // We do a comparison of the supplied compareForUpdate object, to see
    // if anything has changed.
    if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_6___default()(prevProps === null || prevProps === void 0 ? void 0 : prevProps.compareForUpdate, nextProps === null || nextProps === void 0 ? void 0 : nextProps.compareForUpdate)) {
        return true;
    }
    if (aggressivelyMinimizeRendering) {
        return false;
    }
    return true;
};
var transferUpdatingPropsToState = function(props) {
    return {
        compareForUpdate: props.compareForUpdate,
        loading: props.loading,
        error: props.error
    };
};
// FIXME: This is used to help redraw the chart on printing. This may not be
// necessary at all with a rewrite, if so apply it using hooks to easily clean up
// on on dismount.
var mediaQueryList =  true && window.matchMedia && window.matchMedia("print");
var HighchartsGraph = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(HighchartsGraph, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(HighchartsGraph);
    function HighchartsGraph(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, HighchartsGraph);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            config: {},
            updatingProps: {}
        };
        _this.chartRef = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createRef();
        _this.printListener = function() {
            var ref;
            return (ref = _this.getChart()) === null || ref === void 0 ? void 0 : ref.reflow();
        };
        _this.setChartLoadingOrError = function(loading, error) {
            var chart = _this.getChart();
            if (chart) {
                if (error && !_this.props.hideChart) {
                    var _errorMsg;
                    chart.showLoading((_errorMsg = _this.props.errorMsg) !== null && _errorMsg !== void 0 ? _errorMsg : _this.props.t([
                        "shared:errorOcurredTryReloading"
                    ], {
                        defaultValue: "An error occurred! Please try reloading the page."
                    }));
                } else if (loading && !_this.props.hideChart) {
                    chart.showLoading(_this.props.t([
                        "shared:loadingFromServer"
                    ], {
                        defaultValue: "Loading data from server..."
                    }));
                } else {
                    chart.hideLoading();
                }
            }
        };
        _this.getChart = function() {
            var ref, ref1;
            if (typeof _this.props.chartRef === "function") {
                return;
            }
            return (ref1 = (ref = _this.props.chartRef || _this.chartRef) === null || ref === void 0 ? void 0 : ref.current) === null || ref1 === void 0 ? void 0 : ref1.chart;
        };
        var isRTL = [
            "he"
        ].some(function(lang) {
            return _this.props.i18n.language === lang;
        });
        var rtlOptions = {
            tooltip: {
                style: {
                    direction: "rtl",
                    textAlign: "right"
                },
                useHTML: true
            },
            xAxis: {
                labels: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                },
                title: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                }
            },
            yAxis: {
                title: {
                    style: {
                        direction: "rtl",
                        textAlign: "center"
                    },
                    useHTML: true
                }
            },
            legend: {
                rtl: true,
                style: {
                    direction: "rtl",
                    textAlign: "right"
                },
                useHTML: true
            }
        };
        highcharts__WEBPACK_IMPORTED_MODULE_1___default().setOptions((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
            chart: {
                style: {
                    fontFamily: _this.props.theme.typography.fontFamily
                }
            },
            lang: {
                months: _this.props.utils.getMonthArray(new Date(2020, 1, 1)).map(function(month) {
                    return _this.props.utils.format(month, "month");
                }),
                weekdays: _this.props.utils.formatWeekdays("EEEE"),
                shortMonths: _this.props.utils.getMonthArray(new Date(2020, 1, 1)).map(function(month) {
                    return _this.props.utils.format(month, "monthShort");
                })
            },
            global: {
                useUTC: false
            }
        }, isRTL ? rtlOptions : {}, _this.props.options || {}));
        _this.state.updatingProps = transferUpdatingPropsToState(props);
        return _this;
    }
    var _proto = HighchartsGraph.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (mediaQueryList && "removeEventListener" in mediaQueryList) {
            mediaQueryList.removeEventListener("change", this.printListener);
        }
        this.setState({
            updatingProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, transferUpdatingPropsToState(this.props)), {
                compareForUpdate: ""
            })
        });
    };
    _proto.componentDidMount = function componentDidMount() {
        if (mediaQueryList && "addEventListener" in mediaQueryList) {
            mediaQueryList.addEventListener("change", this.printListener);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(_, __) {
        this.setChartLoadingOrError(this.props.loading, this.props.error);
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return shouldUpdate(this.props, nextProps, this.state, nextState, nextProps.aggressivelyMinimizeRendering);
    };
    _proto.render = function render() {
        var ref;
        var _props = this.props, classes = _props.classes, loading = _props.loading, error = _props.error, _configFn = _props.configFn, configFn = _configFn === void 0 ? Function.prototype : _configFn, configOptions = _props.configOptions, chartRef = _props.chartRef, hideChart = _props.hideChart;
        var config = this.state.config;
        if (hideChart) {
            return null;
        }
        // Highcharts for some reason does not use the responsive properties
        // on the initial render, so set the height manually, so the chart does not jump around.
        // A fix for https://github.com/BlackbirdHQ/meta/issues/1607
        var noOfVisibleLegends = Object.values(configFn(configOptions).series).reduce(function(sum, serie) {
            var ref;
            return serie.showInLegend || ((ref = serie.dataLabels) === null || ref === void 0 ? void 0 : ref.enabled) ? sum + 1 : sum;
        }, 0);
        var legendsHeight = noOfVisibleLegends * 16;
        var smallScreen = (180 + legendsHeight).toString();
        var ref1;
        var largeScreen = (ref1 = configOptions === null || configOptions === void 0 ? void 0 : configOptions.height) !== null && ref1 !== void 0 ? ref1 : smallScreen;
        var smallScreenCutoff = 536;
        var chartHeight = window.innerWidth < smallScreenCutoff ? smallScreen : largeScreen;
        var defaultConfig = {
            title: false,
            exporting: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            chart: {
                height: chartHeight
            }
        };
        var ref2, ref3;
        var highchartsConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, defaultConfig, configFn(configOptions)), {
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: smallScreenCutoff
                        },
                        chartOptions: {
                            chart: {
                                height: smallScreen
                            }
                        }
                    }, 
                ]
            },
            plotOptions: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (ref2 = config === null || config === void 0 ? void 0 : config.plotOptions) !== null && ref2 !== void 0 ? ref2 : {}), {
                series: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, (ref3 = config === null || config === void 0 ? void 0 : (ref = config.plotOptions) === null || ref === void 0 ? void 0 : ref.series) !== null && ref3 !== void 0 ? ref3 : {}), {
                    turboThreshold: 0
                })
            })
        });
        highchartsConfig.chart.height = chartHeight;
        if (loading || error) {
            highchartsConfig = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, highchartsConfig), {
                plotOptions: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, highchartsConfig.plotOptions), {
                    series: {
                        animation: false
                    }
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading_overlay_spinner__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                size: 35
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default()), {
                immutable: true,
                options: highchartsConfig,
                highcharts: (highcharts__WEBPACK_IMPORTED_MODULE_1___default()),
                ref: chartRef || this.chartRef,
                domProps: {
                    className: classes.hideOverflow
                },
                callback: this.props.onChartCreated
            })
        });
    };
    /**
   * `getDerivedStateFromProps` is mainly used to calculate if we need to rerun the configuration
   * generation function, `configFn`, or if we can save some processing and skip it.
   */ HighchartsGraph.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        var shouldDerive = shouldUpdate(prevState.updatingProps, nextProps, prevState, undefined, nextProps.aggressivelyMinimizeRendering);
        if (shouldDerive && nextProps.configOptions && nextProps.configFn) {
            var ref, ref1;
            // This ensures we only run the `configFn` once, either after updatingProps are both updated
            // or in the case that they don't exist.
            if (nextProps.compareForUpdate !== undefined && ((ref = prevState.updatingProps) === null || ref === void 0 ? void 0 : ref.compareForUpdate) !== undefined || !nextProps.compareForUpdate === undefined && !((ref1 = prevState.updatingProps) === null || ref1 === void 0 ? void 0 : ref1.compareForUpdate) === undefined) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prevState), {
                    config: nextProps.configFn(nextProps.configOptions),
                    updatingProps: transferUpdatingPropsToState(nextProps)
                });
            }
        }
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, prevState), {
            updatingProps: transferUpdatingPropsToState(nextProps)
        });
    };
    return HighchartsGraph;
}(react__WEBPACK_IMPORTED_MODULE_7__.Component);
var Instance = (highcharts__WEBPACK_IMPORTED_MODULE_1___default());
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_8__/* .compose */ .qC)((0,react_i18next__WEBPACK_IMPORTED_MODULE_17__/* .withTranslation */ .Z)([
    "shared"
]), (0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_18__/* .withStyles */ .D)(styles, {
    withTheme: true
}), _hocs__WEBPACK_IMPORTED_MODULE_19__/* .withUtils */ .W);
var Graph = enhance(HighchartsGraph);


/***/ }),

/***/ 59967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57077);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5887);








var styles = function(_theme) {
    return {
        overlay: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, .3)"
        },
        center: {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)"
        }
    };
};
var LoadingSpinnerOverlay = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(LoadingSpinnerOverlay, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(LoadingSpinnerOverlay);
    function LoadingSpinnerOverlay() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, LoadingSpinnerOverlay);
        return _super.apply(this, arguments);
    }
    var _proto = LoadingSpinnerOverlay.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, size = _props.size;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.overlay,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classes.center,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CircularProgress__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    color: "primary",
                    size: size
                })
            })
        });
    };
    return LoadingSpinnerOverlay;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_7__/* .withStyles */ .D)(styles, {
    withTheme: true
}));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(LoadingSpinnerOverlay));


/***/ }),

/***/ 75743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ determineLabel; }
/* harmony export */ });
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25955);

var determineLabel = function(t, sensor) {
    if (!sensor) {
        var loading = t([
            "shared:loading"
        ], {
            defaultValue: "Loading..."
        });
        return [
            loading,
            loading
        ];
    }
    var ref = sensor.config || {}, type = ref.type, _sensorUnit = ref.sensorUnit, sensorUnit = _sensorUnit === void 0 ? {
        unit: generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .Unit.PCS */ .fb.PCS,
        label: "pcs"
    } : _sensorUnit, chartTimeScale = ref.chartTimeScale, chart = ref.chart;
    var dataFilter = (chart || {}).dataFilter;
    var scale = (chart === null || chart === void 0 ? void 0 : chart.scale) || chartTimeScale || generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .ChartTimeScale.MINUTE */ .cW.MINUTE;
    var unit = (sensorUnit || {}).unit;
    var isUnitless = !unit;
    if (isUnitless) {
        return [
            t("shared:notAvailable", "N/A"),
            ""
        ];
    }
    var isMeasurement = type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .SensorType.MEASUREMENT */ .dE.MEASUREMENT;
    var unitLabel = (sensorUnit === null || sensorUnit === void 0 ? void 0 : sensorUnit.label) || (isMeasurement ? "-" : t("units:piecesShort", "pcs"));
    if (isMeasurement) {
        return [
            unitLabel,
            unitLabel
        ];
    }
    switch(dataFilter){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DataFilter.NONE */ .Zv.NONE:
            return [
                unitLabel,
                unitLabel
            ];
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DataFilter.UPTIME */ .Zv.UPTIME:
            var uptime = t([
                "shared:uptime"
            ], {
                defaultValue: "Uptime"
            });
            return [
                uptime,
                uptime
            ];
    }
    switch(scale){
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .ChartTimeScale.DAY */ .cW.DAY:
            return [
                unitLabel,
                t([
                    "units:unitPerDay"
                ], {
                    defaultValue: "{{unit}}/day",
                    unit: unitLabel
                })
            ];
        case generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .ChartTimeScale.HOUR */ .cW.HOUR:
            return [
                unitLabel,
                t([
                    "units:unitPerHour"
                ], {
                    defaultValue: "{{unit}}/hour",
                    unit: unitLabel
                })
            ];
        default:
            return [
                unitLabel,
                t([
                    "units:unitPerMinute"
                ], {
                    defaultValue: "{{unit}}/min",
                    unit: unitLabel
                })
            ];
    }
};


/***/ }),

/***/ 90527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getManualProcessMinutesProduced; },
/* harmony export */   "R": function() { return /* binding */ getManualProcessSamples; }
/* harmony export */ });
var convertToTimeDate = function(stop) {
    return {
        from: stop.timeRange.from ? new Date(stop.timeRange.from) : null,
        to: stop.timeRange.to ? new Date(stop.timeRange.to) : null
    };
};
var getManualProcessMinutesProduced = function(from, to, stops) {
    var stopTimes = stops.map(convertToTimeDate);
    return getMinutesProduced(from, to, stopTimes);
};
var getMinutesProduced = function(from, to, stopTimes) {
    var duration = to.getTime() - from.getTime();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = stopTimes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stop = _step.value;
            if ((!stop.to || stop.to > from) && (!stop.from || stop.from < to)) {
                var _to, _from;
                var overlapMs = Math.min(((_to = stop.to) !== null && _to !== void 0 ? _to : to).getTime(), to.getTime()) - Math.max(((_from = stop.from) !== null && _from !== void 0 ? _from : from).getTime(), from.getTime());
                duration -= overlapMs;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return duration / 1..minutes;
};
var getManualProcessSamples = function(from, to, stops, points) {
    var result = [];
    var stopTimes = stops.map(convertToTimeDate);
    var duration = to.getTime() - from.getTime();
    var interval = Math.floor(duration / points);
    interval = interval > 30..seconds ? interval : 30..seconds;
    for(var sampleStartMs = from.getTime(); sampleStartMs < to.getTime(); sampleStartMs += interval){
        var sampleStart = new Date(sampleStartMs);
        var sampleEnd = new Date(sampleStartMs + interval - 1);
        result.push(createSample(sampleStart, sampleEnd, getMinutesProduced(sampleStart, sampleEnd, stopTimes)));
    }
    return result;
};
var createSample = function(from, to, value) {
    return {
        timeRange: {
            from: from.toISOString(),
            to: to.toISOString()
        },
        data: {
            accValue: value,
            count: 1,
            minValue: value,
            maxValue: value
        }
    };
};


/***/ }),

/***/ 84521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LB": function() { return /* binding */ pointProcessors; },
/* harmony export */   "RI": function() { return /* binding */ getSerieColor; },
/* harmony export */   "ay": function() { return /* binding */ dataFilters; },
/* harmony export */   "fb": function() { return /* binding */ getOverridesPlotBands; },
/* harmony export */   "i0": function() { return /* binding */ getBatchAndStopsPlotBands; },
/* harmony export */   "n3": function() { return /* binding */ pipePoints; }
/* harmony export */ });
/* unused harmony exports isSample, isVoidData, getMissingData, normalizePoint, evaluateSpeed, getRangeData */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48417);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25955);
/* harmony import */ var lodash_findLastIndex__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71974);
/* harmony import */ var lodash_findLastIndex__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_findLastIndex__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71635);
/* harmony import */ var lodash_sortBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_sortBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3010);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8411);
/* harmony import */ var _lib_highcharts_filters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51169);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52108);











var isSample = function(sample) {
    return typeof sample.data.accValue === "number";
};
var isVoidData = function(sample) {
    return sample.data.accValue === null;
};
var isVoidPoint = function(point) {
    return !!point && typeof point.low !== "number";
};
var diff = function(a, b) {
    return new Date(a).getTime() - new Date(b).getTime();
};
var dataFilters = [
    (0,_lib_highcharts_filters__WEBPACK_IMPORTED_MODULE_3__/* .movingAverage */ .p_)(1)
];
var maybeApplyDiscontinuity = function(param, predicate) {
    var prev = param.prev, current = param.current, next = param.next;
    var slice = [];
    if (predicate(prev)) {
        slice.push({
            x: current.x - 1
        });
    }
    slice.push(current);
    if (predicate(next)) {
        slice.push({
            x: current.x + 1
        });
    }
    return slice;
};
var instantaneousSpeedProcessor = function(param) {
    var scale = param.scale, perPointSpan = param.perPointSpan;
    return function(point, index, points) {
        if (isVoidPoint(point)) {
            return [];
        }
        var ref = [
            points[0],
            points[index - 1],
            points[index + 1]
        ], firstPoint = ref[0], prev = ref[1], next = ref[2];
        if (!prev) {
            return [];
        }
        var isPreviousPointVoid = isVoidPoint(prev);
        var pastPoint = isPreviousPointVoid ? points[lodash_findLastIndex__WEBPACK_IMPORTED_MODULE_0___default()(points, function(point) {
            return !isVoidPoint(point);
        }, index - 1)] || firstPoint : prev;
        // NOTE: If a device has been offline for a while, perPointSpan may not be the right duration to pick, we effectively
        // need the last online sample.
        var duration = isPreviousPointVoid ? point.x - pastPoint.x : perPointSpan;
        return maybeApplyDiscontinuity({
            prev: prev,
            current: evaluateSpeed({
                value: point.y - pastPoint.y,
                timestamp: point.x
            }, duration, scale),
            next: next
        }, isVoidPoint);
    };
};
var getSerieColor = function(type, sensorIndex) {
    if (type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_4__/* .SensorType.MEASUREMENT */ .dE.MEASUREMENT) {
        return _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .MEASUREMENT_CHART_COLORS */ .bW[sensorIndex % _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .MEASUREMENT_CHART_COLORS.length */ .bW.length];
    } else if (type === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_4__/* .SensorType.MANUAL_PROCESS */ .dE.MANUAL_PROCESS) {
        return _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .MANUAL_PROCESS_COLORS */ .s6[sensorIndex % _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .MANUAL_PROCESS_COLORS.length */ .s6.length];
    } else {
        return _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .CHART_COLORS */ .ZE[sensorIndex % _lib_highcharts_data_config__WEBPACK_IMPORTED_MODULE_5__/* .CHART_COLORS.length */ .ZE.length];
    }
};
var averageSpeedProcessor = function(param) {
    var scale = param.scale, perPointSpan = param.perPointSpan;
    return function(point, index, points) {
        if (!points.length) {
            return [];
        }
        if (isVoidPoint(point)) {
            return [];
        }
        var lookBackNumIndices = Math.ceil(scale / perPointSpan) || 1;
        var pastPoint = function() {
            var pastIndex = Math.max(0, index - lookBackNumIndices);
            var pastPoint = points[pastIndex];
            return isVoidPoint(pastPoint) && points[lodash_findLastIndex__WEBPACK_IMPORTED_MODULE_0___default()(points, function(point) {
                return !isVoidPoint(point);
            }, pastIndex)] || pastPoint;
        }();
        if (pastPoint === point) {
            return [];
        }
        var duration = point.x - pastPoint.x;
        var ref = [
            points[index - 1],
            points[index + 1]
        ], prev = ref[0], next = ref[1];
        return maybeApplyDiscontinuity({
            prev: prev,
            current: evaluateSpeed({
                value: point.y - pastPoint.y,
                timestamp: point.x
            }, duration, scale),
            next: next
        }, isVoidPoint);
    };
};
var normalizeProcessor = function(param) {
    var average = param.average;
    return function(point, index, points) {
        if (isVoidPoint(point)) {
            return [];
        }
        var ref = [
            points[index - 1],
            points[index + 1]
        ], prev = ref[0], next = ref[1];
        if (!prev) {
            return [];
        }
        return maybeApplyDiscontinuity({
            prev: prev,
            current: normalizePoint({
                value: point.y - prev.y,
                timestamp: point.x,
                count: average ? point.count : 1
            }),
            next: next
        }, isVoidPoint);
    };
};
var uptimeProcessor = function() {
    return function(point, index, points) {
        if (isVoidPoint(point)) {
            return [];
        }
        var prev = points[index - 1];
        if (!prev) {
            return [];
        }
        return [
            {
                x: point.x,
                y: point.y - prev.y ? 1 : 0
            }, 
        ];
    };
};
var voidProcessor = function(param) {
    var average = param.average, now = param.now;
    return function(current, index, points) {
        var isBeforeMostRecentMinute = function() {
            return current.x < now - 1..minutes;
        };
        if (!isVoidPoint(current) || !isBeforeMostRecentMinute() || index === points.length - 1) {
            return [];
        }
        var ref = [
            points[index - 1],
            points[index + 1],
            points[points.length - 1]
        ], prev = ref[0], next = ref[1], last = ref[2];
        var y = average ? (last.globalHigh + last.globalLow) / 2 : 0;
        return maybeApplyDiscontinuity({
            prev: prev,
            current: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, current), {
                y: y
            }),
            next: next
        }, function(point) {
            return !isVoidPoint(point);
        });
    };
};
var varianceProcessor = function(param) {
    var isMeasurement = param.isMeasurement;
    return function(current, index, points) {
        if (!isMeasurement) {
            return [];
        }
        if (isVoidPoint(current)) {
            return [];
        }
        var ref = [
            points[index - 1],
            points[index + 1]
        ], prev = ref[0], next = ref[1];
        return maybeApplyDiscontinuity({
            prev: prev,
            current: current,
            next: next
        }, isVoidPoint);
    };
};
var pointProcessors = {
    NONE: normalizeProcessor,
    UPTIME: uptimeProcessor,
    SPEED: instantaneousSpeedProcessor,
    AVERAGE_SPEED: averageSpeedProcessor,
    VOID: voidProcessor,
    VARIANCE: varianceProcessor
};
var pipePoints = function(samples, composers) {
    // NOTE: Pipe composers with pass-by-reference collection (the processor
    // mutates)
    var pipe = composers.reduce(function(pipe, composer, composerIndex) {
        return function(collections, point, index, points) {
            var _composerIndex;
            (_composerIndex = collections[composerIndex]).push.apply(_composerIndex, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(composer(point, index, points)));
            return pipe(collections, point, index, points);
        };
    }, function(collections, _point, _index, _points) {
        return collections;
    });
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(samples.reduce(function(param, sample) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(param, 4), cumsum = _param[0], prevMinValue = _param[1], prevValue = _param[2], prevMaxValue = _param[3];
        var _data = sample.data, minValue = _data.minValue, accValue = _data.accValue, maxValue = _data.maxValue, count = _data.count;
        var value = prevValue + (accValue || 0);
        var globalLow = Math.min(prevMinValue, minValue || 0);
        var globalHigh = Math.max(prevMaxValue, maxValue || 0);
        cumsum.push({
            x: new Date(sample.timeRange.to).getTime(),
            y: value,
            low: typeof minValue === "number" ? minValue : undefined,
            high: typeof maxValue === "number" ? maxValue : undefined,
            count: count,
            globalLow: globalLow,
            globalHigh: globalHigh
        });
        return [
            cumsum,
            globalLow,
            value,
            globalHigh
        ];
    }, [
        [],
        Infinity,
        0,
        -Infinity
    ]), 1), normalizedCumSum = ref[0];
    return normalizedCumSum.reduce(pipe, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(composers.map(function() {
        return [];
    })));
};
var getMissingData = function(p) {
    return {
        // FIXME: Type this properly
        x: new Date(p.timeRange.to).getTime() || undefined,
        y: p.data.accValue === null ? 0 : undefined
    };
};
var normalizePoint = function(param) {
    var timestamp = param.timestamp, value = param.value, count = param.count;
    return {
        x: timestamp,
        y: value / (count || 1)
    };
};
var evaluateSpeed = function(param, duration, scale) {
    var timestamp = param.timestamp, value = param.value;
    return {
        x: timestamp,
        y: value / (duration || 1) * scale
    };
};
var getRangeData = function(p, type) {
    var chartTimeScale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Schema.ChartTimeScale.MINUTE;
    var timeDiff = diff(p.timeRange.to, p.timeRange.from) === 0 ? 1 : diff(p.timeRange.to, p.timeRange.from);
    if (type === Schema.SensorType.MEASUREMENT) {
        return {
            x: new Date(p.timeRange.from).getTime(),
            low: p.data.minValue !== undefined && p.data.minValue !== null ? p.data.minValue : undefined,
            high: p.data.maxValue !== undefined && p.data.maxValue !== null ? p.data.maxValue : undefined
        };
    }
    var count = p.data.count || 1;
    return {
        x: new Date(p.timeRange.from).getTime(),
        low: p.data.minValue !== undefined && p.data.minValue !== null ? p.data.minValue * count / timeDiff * (chartTimeScale === Schema.ChartTimeScale.HOUR ? 1..hours : 1..minutes) : undefined,
        high: p.data.maxValue !== undefined && p.data.maxValue !== null ? p.data.maxValue * count / timeDiff * (chartTimeScale === Schema.ChartTimeScale.HOUR ? 1..hours : 1..minutes) : undefined
    };
};
var getBatchAndStopsPlotBands = function(batches) {
    var stops = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], time = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, theme = arguments.length > 3 ? arguments[3] : void 0, showStopLabels = arguments.length > 4 ? arguments[4] : void 0;
    batches = lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2___default()(batches, "batchId");
    batches = lodash_sortBy__WEBPACK_IMPORTED_MODULE_1___default()(batches, [
        "actualStart"
    ]);
    batches = !time ? batches : batches.filter(function(b) {
        if (time.to && b.actualStart && new Date(b.actualStart) >= time.to) {
            return false;
        } else if (time.from && b.actualStop && new Date(b.actualStop) <= time.from) {
            return false;
        }
        return true;
    });
    var batchColors = [
        "rgba(100,100,100,0.2)",
        "rgba(50,130,210,0.2)"
    ];
    var batchesPlotBands = batches.map(function(batch, i) {
        if (!batch.actualStart) {
            return;
        }
        return {
            from: new Date(batch.actualStart).getTime(),
            to: batch.actualStop ? new Date(batch.actualStop).getTime() : Date.now(),
            color: batchColors[i % batchColors.length],
            id: batch.batchId,
            zIndex: 5,
            label: {
                // @ts-ignore - no longer available?
                useHTML: true,
                text: "",
                style: {
                    width: 100,
                    textOverflow: "ellipsis",
                    title: ""
                },
                rotation: 90,
                textAlign: "left",
                verticalAlign: "top"
            }
        };
    }).filter(_types__WEBPACK_IMPORTED_MODULE_10__/* .isTruthy */ .f);
    var stopPlotBands = (stops || []).map(function(stop) {
        var causeType = stop.stopCause ? stop.stopCause.stopType : "UNREGISTERED_PLOT_BAND";
        return {
            from: new Date(stop.timeRange.from).getTime(),
            to: new Date(stop.timeRange.to).getTime(),
            color: theme.blackbird.stops[causeType].color.normal,
            id: stop.timeRange.from,
            label: {
                // @ts-ignore - no longer available? It's SVGElement now, so perhaps we
                // can render it directly with React instead.
                useHTML: true,
                text: showStopLabels && stop.stopCause ? stop.stopCause.name : "",
                style: {
                    width: 100,
                    textOverflow: "ellipsis",
                    title: stop.stopCause ? stop.stopCause.name : ""
                },
                rotation: 90,
                textAlign: "left",
                verticalAlign: "top"
            },
            zIndex: 0
        };
    });
    return batchesPlotBands.concat(stopPlotBands);
};
// FIXME: it will be nice to remove the code duplication from the different plot bands and
// use some function to get constants like the zIndex or the color
var getOverridesPlotBands = function(overrides) {
    var time = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, theme = arguments.length > 2 ? arguments[2] : void 0, onClickHandler = arguments.length > 3 ? arguments[3] : void 0;
    return (overrides || []).map(function(override) {
        return {
            from: new Date(override.timeRange.from).getTime(),
            to: new Date(override.timeRange.to).getTime(),
            color: "rgba(210, 50, 90, 0.24)",
            id: override.timeRange.from,
            label: {
                // @ts-ignore
                useHTML: true,
                // FIXME: if the text is too long maybe show a part of it and the rest if the mouse goes over ...
                text: "".concat(override.author, ": ").concat(override.comment),
                rotation: 90,
                textAlign: "left",
                verticalAlign: "top"
            },
            zIndex: 7,
            events: {
                click: function click(e) {
                    if (!e) {
                        return;
                    }
                    if (onClickHandler) {
                        e.preventDefault();
                        onClickHandler(override);
                    }
                }
            }
        };
    });
};


/***/ }),

/***/ 8411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZE": function() { return /* binding */ CHART_COLORS; },
  "s6": function() { return /* binding */ MANUAL_PROCESS_COLORS; },
  "bW": function() { return /* binding */ MEASUREMENT_CHART_COLORS; },
  "ZP": function() { return /* binding */ data_config; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(69648);
;// CONCATENATED MODULE: ../../modules/common/dist/es/helpers.js


var AlarmId = /*#__PURE__*/ function() {
    "use strict";
    function AlarmId(sk) {
        (0,_class_call_check/* default */.Z)(this, AlarmId);
        this.sk = sk;
    }
    (0,_create_class/* default */.Z)(AlarmId, [
        {
            key: "rawSK",
            get: function get() {
                return this.sk;
            }
        },
        {
            key: "alarmUUID",
            get: function get() {
                return this.sk.startsWith("invalidated|") ? this.sk.split("|")[2] : this.sk;
            }
        },
        {
            key: "invalidatedDate",
            get: function get() {
                var result = this.sk.startsWith("invalidated|") ? this.sk.split("|")[1] : null;
                return result !== null && Date.parse(result) ? new Date(result) : null;
            }
        }
    ]);
    return AlarmId;
}();

// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/highcharts@10.3.3/node_modules/highcharts/highcharts.js
var highcharts = __webpack_require__(88231);
var highcharts_default = /*#__PURE__*/__webpack_require__.n(highcharts);
// EXTERNAL MODULE: ../../node_modules/.pnpm/highcharts@10.3.3/node_modules/highcharts/modules/annotations.js
var annotations = __webpack_require__(21742);
var annotations_default = /*#__PURE__*/__webpack_require__.n(annotations);
// EXTERNAL MODULE: ../../node_modules/.pnpm/highcharts@10.3.3/node_modules/highcharts/modules/xrange.js
var xrange = __webpack_require__(61361);
var xrange_default = /*#__PURE__*/__webpack_require__.n(xrange);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/has.js
var has = __webpack_require__(45346);
var has_default = /*#__PURE__*/__webpack_require__.n(has);
// EXTERNAL MODULE: ./helpers/helper-functions.ts
var helper_functions = __webpack_require__(15608);
// EXTERNAL MODULE: ./helpers/highcharts.ts
var helpers_highcharts = __webpack_require__(75743);
;// CONCATENATED MODULE: ./helpers/truncation.ts
var truncateDataValue = function(value) {
    return value.toFixed(3);
};

// EXTERNAL MODULE: ./lib/highcharts/filters.ts
var filters = __webpack_require__(51169);
// EXTERNAL MODULE: ./lib/highcharts/config-helpers.ts
var config_helpers = __webpack_require__(84521);
;// CONCATENATED MODULE: ./lib/highcharts/data-config.ts















// Modules can not be server-side rendered
if (typeof (highcharts_default()) === "object") {
    annotations_default()((highcharts_default()));
    xrange_default()((highcharts_default()));
}
var CHART_COLORS = [
    {
        color: "#7cb5ec",
        variance: "#7cb5ec"
    },
    {
        color: "#8bbc21",
        variance: "#8bbc21"
    },
    {
        color: "#910000",
        variance: "#910000"
    },
    {
        color: "#1aadce",
        variance: "#1aadce"
    },
    {
        color: "#492970",
        variance: "#492970"
    },
    {
        color: "#f28f43",
        variance: "#f28f43"
    },
    {
        color: "#77a1e5",
        variance: "#77a1e5"
    },
    {
        color: "#c42525",
        variance: "#c42525"
    },
    {
        color: "#0d233a",
        variance: "#0d233a"
    },
    {
        color: "#a6c96a",
        variance: "#a6c96a"
    },
    {
        color: "#7a3a3a",
        variance: "#7a3a3a"
    },
    {
        color: "#ffa500",
        variance: "#ffa500"
    },
    {
        color: "#070",
        variance: "#070"
    },
    {
        color: "#48d1cc",
        variance: "#48d1cc"
    },
    {
        color: "#f08080",
        variance: "#f08080"
    },
    {
        color: "#008b8b",
        variance: "#008b8b"
    },
    {
        color: "#2f4f4f",
        variance: "#2f4f4f"
    },
    {
        color: "#8f3090",
        variance: "#8f3090"
    },
    {
        color: "#757a3a",
        variance: "#757a3a"
    },
    {
        color: "#00f",
        variance: "#00f"
    }, 
];
// For the MEASUREMENT_CHART_COLORS, we reuse the colors, except changing the first color to green.
var MEASUREMENT_CHART_COLORS = CHART_COLORS.map(function(color, i) {
    return i === 0 ? {
        color: "green",
        variance: "rgba(0, 127, 0, 0.3)"
    } : color;
});
var MANUAL_PROCESS_COLORS = CHART_COLORS.map(function(color, i) {
    return i === 0 ? {
        color: "#aadea7",
        variance: "rgba(0, 127, 0, 0.3)"
    } : color;
});
// This method was made to better control the styling of the tooltips.
// Problems occured when trying to color previous <b> tag elements,
// which is why we now use font-weight: bold instead.
var colorSpanWrap = function(text, color, options) {
    if (color) {
        var style = "";
        if (options && options.bold) {
            style = "color: " + color + "; font-weight: bold;";
        } else {
            style = "color: " + color + ";";
        }
        if (options && options.newLine) {
            return '<span style="'.concat(style, '">').concat(text, "</span><br />");
        }
        return '<span style="'.concat(style, '">').concat(text, " </span>");
    }
    if (options && options.newLine) {
        return "<span>".concat(text, "</span><br />");
    }
    return "<span>".concat(text, " </span>");
};
/**
 * Construct a list of alarm limits to display on the graph.
 */ var createNonOverlappinAlarmLimits = function(samplesTimeEnd, theme, alarms) {
    var alarmLimits = [];
    // We avoid overlaps by moving the labels around based on their grouping number:
    //    0: left above
    //    1: right above
    //    2: left below
    //    3: right below
    //    4: center below
    //    5: center above
    // etc...
    var groupingCount = [];
    // Only show enabled alarms on the live graph. Also only display alarms that have a configured x
    alarms = alarms.filter(function(alarm) {
        return alarm.enabled && alarm.alarmConfiguration.x;
    });
    // Construct the alarm limits.
    alarms.map(function(alarm) {
        // We made sure that `alarm.alarmConfiguration.x` has a value in the above filter
        var x = alarm.alarmConfiguration.x;
        if (has_default()(groupingCount, x.toString())) {
            groupingCount[x] += 1;
        } else {
            groupingCount[x] = 0;
        }
        var grouping = groupingCount[x];
        var color = "#d9534f";
        if (theme && theme.blackbird && theme.blackbird.alarms && theme.blackbird.alarms.type[alarm.type]) {
            color = theme.blackbird.alarms.type[alarm.type].color;
        }
        // FIXME: Dunno what the implications of an alarm without a time range would
        // be - let's wing it
        if (!alarm.timeRange) {
            return;
        }
        var alarmTo = alarm.timeRange.to ? new Date(alarm.timeRange.to).getTime() : Date.now();
        var ref;
        alarmLimits.push({
            id: alarm.id,
            value: x,
            // FIXME: I don't think it makes sense to have falsy time ranges - this should be fixed in the API
            from: new Date(alarm.timeRange.from).getTime(),
            // Clip the time into the requested time. Do not let the alarm time be after the requested time.
            to: Math.min((ref = samplesTimeEnd === null || samplesTimeEnd === void 0 ? void 0 : samplesTimeEnd.getTime()) !== null && ref !== void 0 ? ref : Number.MAX_SAFE_INTEGER, alarmTo),
            color: color,
            dashStyle: "LongDashDotDot",
            width: 1,
            // useHTML: true,
            label: {
                // text: '<span style="color: ' + color + ';">♦ </span><span>' + alarm.name + '</span>',
                text: alarm.name,
                align: grouping >= 4 && grouping <= 5 ? "center" : grouping % 2 === 0 ? "left" : "right",
                y: grouping % 4 <= 1 ? -5 : 16,
                x: grouping >= 4 && grouping <= 5 ? 0 : grouping % 2 === 0 ? 5 : -5
            },
            zIndex: 4
        });
    });
    return alarmLimits;
};
var getBatchSpeed = function(x, batches, speedType) {
    var matchingBatch = batches.map(function(batch) {
        if (!(x < Date.parse(batch.actualStart) || Date.parse(batch.actualStop) < x)) {
            if (speedType === "expected") {
                return batch.product.expectedAverageSpeed;
            } else if (speedType === "validated") {
                return batch.product.validatedLineSpeed;
            }
        }
        return null;
    });
    return matchingBatch ? matchingBatch.find(function(batch) {
        return batch;
    }) : null;
};
var getMaxValidatedSpeed = function(batches, validatedSpeed) {
    var chartTimeScale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    var max = 0;
    batches.map(function(batch) {
        var batchSpeed = batch.product.validatedLineSpeed * (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1);
        max = batchSpeed > max ? batchSpeed : max;
    });
    return max === 0 ? validatedSpeed : max;
};
var customUnitTranslation = function(t, transBatchDataUnit) {
    var chartTimeScale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    if (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR) {
        return t([
            "shared:customUnitPrHour"
        ], {
            defaultValue: "{{transBatchDataUnit}}/hour",
            transBatchDataUnit: transBatchDataUnit
        });
    }
    if (chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY) {
        return t([
            "shared:customUnitPrDay"
        ], {
            defaultValue: "{{transBatchDataUnit}}/day",
            transBatchDataUnit: transBatchDataUnit
        });
    }
    return t([
        "shared:customUnitPrMin"
    ], {
        defaultValue: "{{transBatchDataUnit}}/min",
        transBatchDataUnit: transBatchDataUnit
    });
};
var getBatchInfo = function(batches, dataUnit, noActStops, t, x) {
    var chartTimeScale = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    // FIXME: Handle the case where actualStart isn't set - or change the
    // interface if that is never possible.
    var batchStart = batches.map(function(batch) {
        return new Date(batch.actualStart).getTime();
    });
    var batchStop = batches.map(function(batch) {
        return batch.actualStop ? new Date(batch.actualStop).getTime() : Date.now();
    });
    var currentBatch;
    var i = 0;
    for(i = 0; i < batchStart.length; i++){
        if (x > batchStart[i] && x < batchStop[i]) {
            currentBatch = batches[i];
            break;
        }
    }
    var noBatchInformation = true;
    var batchString = t([
        "shared:noBatchInformation"
    ], {
        defaultValue: "No batch information"
    });
    if (currentBatch) {
        var ref, ref1, ref2, ref3;
        var noActTimeInBatch = 0;
        noActStops.forEach(function(stop) {
            // FIXME: Handle nullish values for from/to
            var from = new Date(stop.timeRange.from).getTime();
            var to = new Date(stop.timeRange.to).getTime();
            if (from >= batchStart[i] && from <= batchStop[i]) {
                if (to > batchStop[i]) {
                    noActTimeInBatch += batchStop[i] - from;
                } else {
                    noActTimeInBatch += to - from;
                }
            }
        });
        var ref4;
        var produced = (ref4 = currentBatch === null || currentBatch === void 0 ? void 0 : (ref = currentBatch.stats) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.produced) !== null && ref4 !== void 0 ? ref4 : 0;
        var batchExpectedSpeed = currentBatch.product.expectedAverageSpeed * (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1);
        var batchValidatedSpeed = currentBatch.product.validatedLineSpeed * (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1);
        var averageProduced = produced / ((batchStop[i] - (batchStart[i] + noActTimeInBatch)) / ((chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 * 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 60 * 24 : 60) * 1000));
        var targetToExpected = 100 * produced / currentBatch.amount;
        var producedStatus = averageProduced > batchExpectedSpeed ? "color:green" : "color:red";
        var targetStatus = targetToExpected > 100 ? "color:green" : "color:red";
        var ref5;
        var batchDataUnit = (ref5 = (ref2 = currentBatch.product) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.packaging) === null || ref3 === void 0 ? void 0 : ref3.unit) !== null && ref5 !== void 0 ? ref5 : dataUnit;
        var batchDataUnitLabel = customUnitTranslation(t, batchDataUnit, chartTimeScale);
        batchString = "".concat(t([
            "shared:product"
        ], {
            defaultValue: "Product"
        }), ": ").concat(currentBatch.product.name, " <br />\n                  ").concat(t([
            "shared:batchNumber"
        ], {
            defaultValue: "Batch/PO number"
        }), ": ").concat(currentBatch.batchNumber, " <br />\n                  ").concat(t([
            "shared:batchSize"
        ], {
            defaultValue: "Batch size"
        }), ": ").concat(currentBatch.amount, " <br />\n                  ").concat(t([
            "shared:itemsProduced"
        ], {
            defaultValue: "Items produced"
        }), ": ").concat(Math.floor(produced), " <br />\n                  ").concat(t([
            "shared:expectedProductSpeed"
        ], {
            defaultValue: "Expected product speed"
        }), ": ").concat(batchExpectedSpeed, " ").concat(batchDataUnitLabel, "<br />\n                  ").concat(t([
            "shared:validatedProductSpeed"
        ], {
            defaultValue: "Validated product speed"
        }), ": ").concat(batchValidatedSpeed, " ").concat(batchDataUnitLabel, "<br />\n                  ").concat(t([
            "shared:averageProduced"
        ], {
            defaultValue: "Average produced"
        }), ': <span style="').concat(producedStatus, '">').concat(averageProduced.toFixed(1), " </span> ").concat(batchDataUnitLabel, " <br />\n                  ").concat(t([
            "shared:completePercentage"
        ], {
            defaultValue: "Complete percentage"
        }), ': <span style="').concat(targetStatus, '">').concat(targetToExpected.toFixed(1), " </span> %");
        noBatchInformation = false;
    }
    return {
        batchString: batchString,
        noBatchInformation: noBatchInformation
    };
};
var getPlotBands = function(isASingleSensor, time, theme, showStops, onClickHandler) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    if (!isASingleSensor) {
        return undefined;
    }
    var plotbands = [];
    var ref7;
    if (((ref7 = isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref = isASingleSensor.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.batches) === null || ref2 === void 0 ? void 0 : ref2.items) !== null && ref7 !== void 0 ? ref7 : []).length || (isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref3 = isASingleSensor.time) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.stops)) {
        var _plotbands;
        var ref8, ref9, ref10, ref11, ref12;
        var ref13, ref14;
        (_plotbands = plotbands).push.apply(_plotbands, (0,_to_consumable_array/* default */.Z)((0,config_helpers/* getBatchAndStopsPlotBands */.i0)((ref13 = isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref8 = isASingleSensor.time) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.batches) === null || ref10 === void 0 ? void 0 : ref10.items) !== null && ref13 !== void 0 ? ref13 : [], (ref14 = isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref11 = isASingleSensor.time) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.stops) !== null && ref14 !== void 0 ? ref14 : [], time, theme, showStops)));
    }
    var ref15;
    if (((ref15 = isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref5 = isASingleSensor.time) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.dataOverrides) !== null && ref15 !== void 0 ? ref15 : []).length) {
        var _plotbands1;
        var ref16, ref17;
        var ref18;
        (_plotbands1 = plotbands).push.apply(_plotbands1, (0,_to_consumable_array/* default */.Z)((0,config_helpers/* getOverridesPlotBands */.fb)((ref18 = isASingleSensor === null || isASingleSensor === void 0 ? void 0 : (ref16 = isASingleSensor.time) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.dataOverrides) !== null && ref18 !== void 0 ? ref18 : [], time, theme, onClickHandler)));
    }
    return plotbands;
};
var getConfig = function(param) {
    var t = param.t, language = param.language, theme = param.theme, height = param.height, refetch = param.refetch, _sensors = param.sensors, sensors = _sensors === void 0 ? [] : _sensors, time = param.time, client = param.client, onClickStop = param.onClickStop, colorsWithHidden = param.colorsWithHidden, _disableTooltip = param.disableTooltip, disableTooltip = _disableTooltip === void 0 ? false : _disableTooltip, _disableBatchPlotBands = param.disableBatchPlotBands, disableBatchPlotBands = _disableBatchPlotBands === void 0 ? false : _disableBatchPlotBands, _disableAxisLabel = param.disableAxisLabel, disableAxisLabel = _disableAxisLabel === void 0 ? false : _disableAxisLabel, _disableExportMenu = param.disableExportMenu, disableExportMenu = _disableExportMenu === void 0 ? false : _disableExportMenu, _showTargets = param.showTargets, showTargets = _showTargets === void 0 ? false : _showTargets, _legends = param.legends, legends = _legends === void 0 ? {
        validatedSpeed: false,
        expectedSpeed: false,
        showStops: false,
        showAnnotations: false
    } : _legends, _setLegends = param.setLegends, setLegends = _setLegends === void 0 ? Function.prototype : _setLegends, setSelectedTime = param.setSelectedTime, selectedTime = param.selectedTime, onClickHandler = param.onClickHandler, onAnnotationClicked = param.onAnnotationClicked, _showLegend = param.showLegend, showLegend = _showLegend === void 0 ? true : _showLegend, _hideLegends = param.hideLegends, hideLegends = _hideLegends === void 0 ? {} : _hideLegends;
    var _Math;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var alarms = sensors.reduce(function(alarms, param) {
        var sensorAlarms = param.alarms;
        if (sensorAlarms) {
            var _alarms;
            (_alarms = alarms).push.apply(_alarms, (0,_to_consumable_array/* default */.Z)(sensorAlarms));
        }
        return alarms;
    }, []);
    var samples = sensors === null || sensors === void 0 ? void 0 : (ref = sensors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.time) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.samples;
    var ref15;
    var lastIndex = (ref15 = (samples === null || samples === void 0 ? void 0 : samples.length) - 1) !== null && ref15 !== void 0 ? ref15 : 0;
    var samplesEndTime = samples === null || samples === void 0 ? void 0 : (ref3 = samples[lastIndex]) === null || ref3 === void 0 ? void 0 : ref3.timeRange.to;
    var alarmLimits = alarms ? createNonOverlappinAlarmLimits(samplesEndTime ? new Date(samplesEndTime) : null, theme, alarms) : [];
    var hasOnlyOneSensor = sensors.length === 1;
    var _sensors1 = (0,_sliced_to_array/* default */.Z)(sensors, 1), tmp = _sensors1[0], primarySensor = tmp === void 0 ? null : tmp;
    var ref16;
    var primarySensorChartTimeScale = (ref16 = primarySensor === null || primarySensor === void 0 ? void 0 : (ref4 = primarySensor.config) === null || ref4 === void 0 ? void 0 : ref4.chartTimeScale) !== null && ref16 !== void 0 ? ref16 : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,helpers_highcharts/* determineLabel */.t)(t, primarySensor), 2), yAxisLabel = ref17[1];
    // TODO: Clean up this mess - this config contains so much redundant and
    // branching code. 70% is unnecessary.
    var processorConfiguration =  false || (primarySensor === null || primarySensor === void 0 ? void 0 : (ref5 = primarySensor.config) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chart) === null || ref6 === void 0 ? void 0 : ref6.dataFilter) || schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED;
    var isUptime = processorConfiguration === schema/* DataFilter.UPTIME */.Zv.UPTIME;
    var tooltipEnabled = !disableTooltip;
    var exportEnabled = tooltipEnabled && !disableExportMenu;
    var ref18;
    var expectedSpeed = Math.round(((ref18 = (ref7 = sensors[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.config) === null || ref8 === void 0 ? void 0 : ref8.expectedSpeed) !== null && ref18 !== void 0 ? ref18 : 0) * (primarySensorChartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : primarySensorChartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1) * 100) / 100;
    var validatedSpeed = Math.round((_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(sensors.map(function(s) {
        var ref;
        return ((ref = s.config) === null || ref === void 0 ? void 0 : ref.validatedSpeed) || 0;
    }))) * (primarySensorChartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : primarySensorChartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1) * 100) / 100;
    var ref19;
    var maxValidatedSpeed = getMaxValidatedSpeed((ref19 = (ref9 = sensors[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.time) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.batches) === null || ref12 === void 0 ? void 0 : ref12.items) !== null && ref19 !== void 0 ? ref19 : [], validatedSpeed, primarySensorChartTimeScale);
    var anyDateWithData;
    var cleanupFunctions = [];
    var ref20, ref21;
    var plotConfig = {
        boost: {
            enabled: false,
            // Perform value to pixel translations in the shader, rather than on the GPU. This may have adverse
            // effects on some datasets (especially those where floating point precision may be an issue, such
            // as timestamps with small intervals).
            useGPUTranslations: false,
            // If set to true, a native Float32Array buffer will be used directly for adding series points to the
            // internal vertex buffers. This speeds up series processing significantly. It’s well-suited for bubble,
            // scatter, column, and bar charts.
            usePreallocated: false,
            // If set to true, the whole chart will be boosted if all of its series are supported by the boost module,
            // and if at least one series crosses its boost threshold.
            allowForce: false
        },
        exporting: {
            enabled: exportEnabled,
            chartOptions: {
                title: {
                    text: sensors.map(function(s) {
                        return s.name;
                    }).join(",")
                }
            },
            scale: 2,
            sourceWidth: 1200,
            // @ts-ignore
            menuItemDefinitions: {
                printChart: {
                    text: t([
                        "shared:printChart"
                    ], {
                        defaultValue: "Print chart"
                    })
                },
                downloadPNG: {
                    text: t([
                        "shared:downloadPNG"
                    ], {
                        defaultValue: "Download PNG image"
                    })
                },
                downloadJPEG: {
                    text: t([
                        "shared:downloadJPEG"
                    ], {
                        defaultValue: "Download JPEG image"
                    })
                },
                downloadPDF: {
                    text: t([
                        "shared:downloadPDF"
                    ], {
                        defaultValue: "Download PDF image"
                    })
                },
                downloadSVG: {
                    text: t([
                        "shared:downloadSVG"
                    ], {
                        defaultValue: "Download SVG image"
                    })
                }
            },
            buttons: {
                contextButton: {
                    y: 0,
                    x: 0,
                    verticalAlign: "bottom",
                    menuItems: [
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downdloadSVG"
                    ]
                }
            }
        },
        chart: {
            resetZoomButton: {
                theme: {
                    display: "none"
                }
            },
            // @ts-ignore - apparently not documented? But it does enable zooming if set...
            zoomType: "x",
            height: height,
            events: {
                click: function click(e) {
                    var ref, ref1;
                    if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.xAxis) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                        var ref2, ref3;
                        setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref2 = e.xAxis) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value));
                    }
                },
                selection: function selection(e) {
                    if (!e.resetSelection && refetch && sensors) {
                        e.preventDefault();
                        refetch(new Date(e.xAxis[0].min), new Date(e.xAxis[0].max), true);
                    }
                },
                load: function load(_) {
                    // NOTE: Highcharts has no onClick callback for annotations, so manually attach
                    // a listener on annotation labels, so that we can open a dialog for modifying annotations
                    if (onAnnotationClicked !== undefined) {
                        var chart = this;
                        var annotations = chart.annotations;
                        annotations.forEach(function(annotation) {
                            annotation.labels.forEach(function(labelEl, idx) {
                                var removeEventFn = highcharts_default().addEvent(labelEl.graphic.element, "click", function(e) {
                                    var id = annotation.options.labels[idx].id;
                                    var label = annotation.options.labels[idx].text;
                                    var obj = {
                                        id: id,
                                        label: label,
                                        tags: [],
                                        timestamp: annotation.options.labels[idx].point.x,
                                        timestampEnd: null
                                    };
                                    onAnnotationClicked(obj);
                                });
                                cleanupFunctions.push(removeEventFn);
                            });
                        });
                    }
                },
                destroy: function() {
                    cleanupFunctions.forEach(function(fn) {
                        fn();
                    });
                }
            }
        },
        series: sensors.reduce(function(series, sensor, index) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
            var ref11;
            // NOTE: The cast here is to workaround __typename - omit recursively fails as well :(
            var querySamples = ((ref11 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.samples) !== null && ref11 !== void 0 ? ref11 : []).filter(function(sample) {
                return !!sample.timeRange.from && !!sample.timeRange.to;
            });
            if (!querySamples.length) {
                return series;
            }
            if (querySamples.length && !anyDateWithData) {
                anyDateWithData = new Date(querySamples[0].timeRange.from);
            }
            var ref12;
            var batches = (ref12 = sensor === null || sensor === void 0 ? void 0 : (ref2 = sensor.time) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.batches) === null || ref4 === void 0 ? void 0 : ref4.items) !== null && ref12 !== void 0 ? ref12 : [];
            var ref13;
            var type = (ref13 = sensor === null || sensor === void 0 ? void 0 : (ref5 = sensor.config) === null || ref5 === void 0 ? void 0 : ref5.type) !== null && ref13 !== void 0 ? ref13 : schema/* SensorType.COUNTER */.dE.COUNTER;
            var isMeasurement = type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT;
            var ref14;
            var chartTimeScale = (ref14 = sensor === null || sensor === void 0 ? void 0 : (ref6 = sensor.config) === null || ref6 === void 0 ? void 0 : ref6.chartTimeScale) !== null && ref14 !== void 0 ? ref14 : schema/* ChartTimeScale.MINUTE */.cW.MINUTE;
            var ref15 = (0,_sliced_to_array/* default */.Z)((0,helpers_highcharts/* determineLabel */.t)(t, sensor || null), 2), dataUnit = ref15[0], yAxisLabel = ref15[1];
            var sensorIndex = sensor && sensor.colorIndex ? sensor.colorIndex : index;
            var color = colorsWithHidden ? colorsWithHidden[sensorIndex % CHART_COLORS.length] : isMeasurement ? MEASUREMENT_CHART_COLORS[sensorIndex % MEASUREMENT_CHART_COLORS.length] : CHART_COLORS[sensorIndex % CHART_COLORS.length];
            var textColor = primarySensor ? "inherit" : color.color;
            var ref16;
            var noActStops = batches && batches.length ? ((ref16 = sensor === null || sensor === void 0 ? void 0 : (ref7 = sensor.time) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.stops) !== null && ref16 !== void 0 ? ref16 : []).filter(function(s) {
                return s && s.stopCause && s.stopCause.stopType === "NO_ACT";
            }) : [];
            var showTargetSpeeds = showTargets && type && (type.startsWith("COUNTER") || type === schema/* SensorType.MANUAL_PROCESS */.dE.MANUAL_PROCESS);
            var scale = function() {
                if (isMeasurement) {
                    return 0;
                }
                switch(chartTimeScale){
                    case schema/* ChartTimeScale.DAY */.cW.DAY:
                        return 1..days;
                    case schema/* ChartTimeScale.HOUR */.cW.HOUR:
                        return 1..hours;
                    case schema/* ChartTimeScale.MINUTE */.cW.MINUTE:
                        return 1..minutes;
                    default:
                        return 0;
                }
            }();
            var isScrapCounter = sensor.isScrapCounter;
            // FIXME: Pick chart selection as first priority
            var dataFilter =  false || ((ref9 = sensor.config) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chart) === null || ref10 === void 0 ? void 0 : ref10.dataFilter) || schema/* DataFilter.AVERAGE_SPEED */.Zv.AVERAGE_SPEED;
            var processor = scale && !isScrapCounter ? dataFilter : schema/* DataFilter.NONE */.Zv.NONE;
            var sampleProcessor = config_helpers/* pointProcessors */.LB[processor];
            var voidProcessor = config_helpers/* pointProcessors.VOID */.LB.VOID;
            var varianceProcessor = config_helpers/* pointProcessors.VARIANCE */.LB.VARIANCE;
            // NOTE: Points are always evenly distributed from the API
            var _querySamples = (0,_sliced_to_array/* default */.Z)(querySamples, 1), firstSample = _querySamples[0];
            var perPointSpan = new Date(firstSample.timeRange.to).getTime() - new Date(firstSample.timeRange.from).getTime();
            var now = Date.now();
            var composers = [
                voidProcessor({
                    average: isMeasurement,
                    now: now
                }),
                sampleProcessor({
                    scale: scale,
                    average: isMeasurement,
                    perPointSpan: perPointSpan
                }),
                varianceProcessor({
                    isMeasurement: isMeasurement
                }), 
            ];
            // FIXME: Once TypeScript gets smart enough with detecting tuple length
            // move the cast to the type argument of reduce.
            var ref17 = (0,_sliced_to_array/* default */.Z)((0,config_helpers/* pipePoints */.n3)(querySamples, composers), 3), voidData = ref17[0], samples = ref17[1], variances = ref17[2];
            var filteredSamples = [
                schema/* DataFilter.NONE */.Zv.NONE,
                schema/* DataFilter.UPTIME */.Zv.UPTIME
            ].every(function(filter) {
                return processor !== filter;
            }) ? (0,filters/* memoizedFiltering */.Nl)(samples, config_helpers/* dataFilters */.ay, {
                peripheralId: "".concat(sensor === null || sensor === void 0 ? void 0 : sensor.peripheralId)
            }) : samples;
            var impulses = processor === schema/* DataFilter.NONE */.Zv.NONE && !isMeasurement;
            series.push(// serie 0, main data line / area graph
            {
                // @ts-ignore
                boostThreshold: 1,
                animation: false,
                type: impulses ? "column" : "line",
                id: sensor.peripheralId,
                name: "",
                data: filteredSamples,
                color: color.color,
                showInLegend: false,
                tooltip: {
                    pointFormatter: function pointFormatter() {
                        var ref;
                        var ref1 = getBatchInfo(batches, dataUnit, noActStops, t, this.x, chartTimeScale), batchString = ref1.batchString, noBatchInformation = ref1.noBatchInformation;
                        if (type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT) {
                            return colorSpanWrap("".concat(t([
                                "shared:avgAbbr"
                            ], {
                                defaultValue: "Avg"
                            }), ": "), textColor) + colorSpanWrap(truncateDataValue(this.y), textColor, {
                                bold: true
                            }) + colorSpanWrap(" ".concat(dataUnit), textColor, {
                                bold: false,
                                newLine: true
                            }) + (disableBatchPlotBands ? "" : colorSpanWrap(batchString, textColor, {
                                newLine: true
                            }));
                        }
                        var isIntegerValue = primarySensor === null || primarySensor === void 0 ? void 0 : primarySensor.isScrapCounter;
                        if (noBatchInformation && ((ref = this.series.chart.series[3]) === null || ref === void 0 ? void 0 : ref.userOptions.visible)) {
                            return colorSpanWrap(this.y.toFixed(isIntegerValue ? 0 : 2), textColor, {
                                bold: true
                            }) + colorSpanWrap(dataUnit, textColor, {
                                newLine: true
                            }) + (disableBatchPlotBands ? "" : colorSpanWrap(batchString, textColor, {
                                newLine: true
                            })) + colorSpanWrap("".concat(t([
                                "shared:expectedSpeed"
                            ], {
                                defaultValue: "Expected speed"
                            }), ": ").concat(expectedSpeed, " ").concat(dataUnit), textColor, {
                                newLine: true
                            }) + colorSpanWrap("".concat(t([
                                "shared:validatedSpeed"
                            ], {
                                defaultValue: "Validated speed"
                            }), ": ").concat(validatedSpeed, " ").concat(dataUnit), textColor, {
                                newLine: true
                            });
                        }
                        return colorSpanWrap(this.y.toFixed(isIntegerValue ? 0 : 2), textColor, {
                            bold: true
                        }) + colorSpanWrap(dataUnit, textColor, {
                            newLine: true
                        }) + (disableBatchPlotBands ? "" : colorSpanWrap(batchString, textColor, {
                            newLine: true
                        }));
                    }
                },
                zIndex: 9999,
                events: {
                    click: function click(e) {
                        if (setSelectedTime) {
                            var ref;
                            setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x));
                        }
                    }
                }
            }, // serie 1, variance graph used with analog
            {
                animation: false,
                type: "arearange",
                name: "Variance",
                id: "".concat(sensor.peripheralId, "-var"),
                data: variances,
                color: color.variance,
                lineWidth: 0,
                fillOpacity: 0.3,
                linkedTo: ":previous",
                tooltip: {
                    pointFormatter: function pointFormatter() {
                        return colorSpanWrap("".concat(t([
                            "shared:minAbbr"
                        ], {
                            defaultValue: "Min"
                        }), ": "), textColor) + colorSpanWrap(truncateDataValue(this.low), textColor, {
                            bold: true
                        }) + colorSpanWrap(" ".concat(dataUnit), textColor, {
                            newLine: true
                        }) + colorSpanWrap("".concat(t([
                            "shared:maxAbbr"
                        ], {
                            defaultValue: "Max"
                        }), ": "), textColor) + colorSpanWrap(truncateDataValue(this.high), textColor, {
                            bold: true
                        }) + colorSpanWrap(" ".concat(dataUnit), textColor, {
                            newLine: true
                        });
                    }
                },
                zIndex: 0,
                marker: {
                    enabled: false
                },
                visible: type === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT,
                events: {
                    click: function click(e) {
                        var ref;
                        if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x)) {
                            var ref1;
                            setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref1 = e.point) === null || ref1 === void 0 ? void 0 : ref1.x));
                        }
                    }
                }
            }, // serie 2, missing data graph
            {
                animation: false,
                type: "line",
                name: "Missing data",
                id: "".concat(sensor.peripheralId, "-md"),
                data: voidData,
                dashStyle: "Dot",
                tooltip: {
                    pointFormatter: function pointFormatter() {
                        var batchString = getBatchInfo(batches, dataUnit, noActStops, t, this.x, chartTimeScale).batchString;
                        return colorSpanWrap("".concat(t([
                            "shared:missingData"
                        ], {
                            defaultValue: "Missing Data"
                        }), "!"), primarySensor ? "red" : color.color, {
                            bold: true,
                            newLine: true
                        }) + (disableBatchPlotBands ? "" : colorSpanWrap(batchString, textColor, {
                            newLine: true
                        }));
                    }
                },
                color: "red",
                lineWidth: 2,
                linkedTo: "0",
                events: {
                    click: function click(e) {
                        var ref;
                        if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x)) {
                            var ref1;
                            setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref1 = e.point) === null || ref1 === void 0 ? void 0 : ref1.x));
                        }
                    }
                }
            });
            if (hideLegends.expectedSpeed !== true) {
                series.push(// serie 3, expected speed line
                {
                    visible: isUptime ? false : legends.expectedSpeed,
                    animation: false,
                    type: "line",
                    name: t([
                        "shared:expectedSpeed"
                    ], {
                        defaultValue: "Expected speed"
                    }),
                    id: "".concat(sensor.peripheralId, "-expSpeed"),
                    data: showTargetSpeeds ? querySamples.map(function(p) {
                        var x = new Date(p.timeRange.from).getTime();
                        var speed = (getBatchSpeed(x, batches, "expected") || 0) * (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1);
                        return {
                            x: x,
                            y: speed ? speed : expectedSpeed
                        };
                    }) : null,
                    color: "black",
                    dashStyle: "Dash",
                    cursor: false,
                    showInLegend: showTargetSpeeds,
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            e.preventDefault();
                            setTimeout(function() {
                                setLegends((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legends), {
                                    expectedSpeed: !legends.expectedSpeed
                                }));
                            });
                        },
                        click: function click(e) {
                            var ref;
                            if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x)) {
                                var ref1;
                                setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref1 = e.point) === null || ref1 === void 0 ? void 0 : ref1.x));
                            }
                        }
                    },
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                animation: false,
                                enabled: false,
                                radiusPlus: 0,
                                lineWidthPlus: 0
                            }
                        }
                    },
                    states: {
                        hover: {
                            lineWidthPlus: 0
                        }
                    },
                    enableMouseTracking: false
                });
            }
            if (hideLegends.validatedSpeed !== true) {
                series.push(// serie 4, validated speed line
                {
                    visible: isUptime ? false : legends.validatedSpeed,
                    animation: false,
                    type: "line",
                    name: t([
                        "shared:validatedSpeed"
                    ], {
                        defaultValue: "Validated speed"
                    }),
                    id: "".concat(sensor.peripheralId, "-valSpeed"),
                    data: showTargetSpeeds ? querySamples.map(function(p) {
                        var x = new Date(p.timeRange.from).getTime();
                        var speed = (getBatchSpeed(x, batches, "validated") || 0) * (chartTimeScale === schema/* ChartTimeScale.HOUR */.cW.HOUR ? 60 : chartTimeScale === schema/* ChartTimeScale.DAY */.cW.DAY ? 60 * 24 : 1);
                        return {
                            x: x,
                            y: speed ? speed : validatedSpeed
                        };
                    }) : null,
                    color: "green",
                    dashStyle: "Dash",
                    cursor: false,
                    showInLegend: showTargetSpeeds,
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            e.preventDefault();
                            setTimeout(function() {
                                setLegends((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legends), {
                                    validatedSpeed: !legends.validatedSpeed
                                }));
                            });
                        },
                        click: function click(e) {
                            var ref;
                            if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.point) === null || ref === void 0 ? void 0 : ref.x)) {
                                var ref1;
                                setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref1 = e.point) === null || ref1 === void 0 ? void 0 : ref1.x));
                            }
                        }
                    },
                    // linkedTo: ':previous',
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                animation: false,
                                enabled: false,
                                radiusPlus: 0,
                                lineWidthPlus: 0
                            }
                        }
                    },
                    states: {
                        hover: {
                            lineWidthPlus: 0
                        }
                    },
                    enableMouseTracking: false
                });
            }
            if (hideLegends.showStops !== true) {
                series.push(// serie 6, line including stops
                {
                    visible: legends.showStops,
                    animation: false,
                    type: "boxplot",
                    color: "red",
                    name: t([
                        "shared:showStops"
                    ], {
                        defaultValue: "Show stops"
                    }),
                    id: "".concat(sensor.peripheralId, "-showStops"),
                    cursor: false,
                    showInLegend: showTargetSpeeds,
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            e.preventDefault();
                            setTimeout(function() {
                                setLegends((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legends), {
                                    showStops: !legends.showStops
                                }));
                            });
                        }
                    },
                    // linkedTo: ':previous',
                    states: {
                        hover: {
                            lineWidthPlus: 0
                        }
                    },
                    enableMouseTracking: false,
                    zIndex: 0
                });
            }
            if (hideLegends.showAnnotations !== true) {
                series.push(// serie 7, line including annotations
                {
                    visible: legends.showAnnotations,
                    animation: false,
                    type: "polygon",
                    color: "black",
                    name: t([
                        "shared:showAnnotations"
                    ], {
                        defaultValue: "Show annotations"
                    }),
                    id: "".concat(sensor.peripheralId, "-showAnnotations"),
                    cursor: false,
                    showInLegend: hasOnlyOneSensor,
                    events: {
                        legendItemClick: function legendItemClick(e) {
                            e.preventDefault();
                            setTimeout(function() {
                                setLegends((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, legends), {
                                    showAnnotations: !legends.showAnnotations
                                }));
                            });
                        }
                    },
                    // linkedTo: ':previous',
                    states: {
                        hover: {
                            lineWidthPlus: 0
                        }
                    },
                    enableMouseTracking: false
                });
            }
            return series;
        }, Array()),
        credits: {
            enabled: false
        },
        legend: {
            enabled: showLegend
        },
        xAxis: [
            {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).millisecond,
                    second: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).second,
                    minute: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).minute,
                    hour: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).hour,
                    day: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).day,
                    week: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).week,
                    month: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).month,
                    year: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).year
                },
                title: {
                    text: disableAxisLabel ? "" : t([
                        "shared:date"
                    ], {
                        defaultValue: "Date"
                    })
                },
                min: time === null || time === void 0 ? void 0 : (ref13 = time.from) === null || ref13 === void 0 ? void 0 : ref13.getTime(),
                max: time === null || time === void 0 ? void 0 : (ref14 = time.to) === null || ref14 === void 0 ? void 0 : ref14.getTime(),
                // We only show the plot bands when we are graphing one series.
                plotBands: getPlotBands(primarySensor, time, theme, legends.showStops, onClickHandler)
            },
            {
                type: "datetime",
                visible: false,
                linkedTo: 0,
                dateTimeLabelFormats: {
                    millisecond: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).millisecond,
                    second: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).second,
                    minute: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).minute,
                    hour: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).hour,
                    day: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).day,
                    week: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).week,
                    month: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).month,
                    year: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).year
                },
                title: {
                    text: "Date1"
                }
            },
            {
                type: "datetime",
                linkedTo: 0,
                // minRange: 10 * 60 * 1000,
                visible: false,
                dateTimeLabelFormats: {
                    millisecond: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).millisecond,
                    second: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).second,
                    minute: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).minute,
                    hour: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).hour,
                    day: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).day,
                    week: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).week,
                    month: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).month,
                    year: (0,helper_functions/* DateTimeLabelFormatBasedOnBrowserLocale */.l8)(language).year
                },
                title: {
                    text: "Date2"
                },
                events: {
                    afterSetExtremes: function afterSetExtremes(e) {
                        e.preventDefault();
                    }
                }
            }, 
        ],
        yAxis: {
            min: sensors.some(function(sensor) {
                var ref;
                return ((ref20 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.config) === null || ref === void 0 ? void 0 : ref.type) !== null && ref20 !== void 0 ? ref20 : schema/* SensorType.COUNTER */.dE.COUNTER) === schema/* SensorType.MEASUREMENT */.dE.MEASUREMENT;
            }) ? undefined : 0,
            max: sensors.every(function(sensor) {
                var ref, ref1;
                return ((ref21 = sensor === null || sensor === void 0 ? void 0 : (ref = sensor.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.samples) !== null && ref21 !== void 0 ? ref21 : []).every(function(p) {
                    return p.data.accValue === 0 || p.data.accValue === null;
                });
            }) ? Math.max(maxValidatedSpeed, 10 / 1.1) * 1.1 : undefined,
            maxPadding: 0.05,
            minRange: 0.01,
            tickInterval: isUptime ? 1 : undefined,
            endOnTick: false,
            title: {
                text: yAxisLabel
            }
        },
        tooltip: {
            enabled: tooltipEnabled,
            shared: true,
            xDateFormat: (0,helper_functions/* xDateFormatBasedOnBrowserLocale */.mc)(language)
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: tooltipEnabled,
                        animation: false
                    },
                    inactive: {
                        opacity: 1
                    }
                }
            },
            area: {
                marker: {
                    radius: 2,
                    enabled: tooltipEnabled
                },
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null,
                events: {}
            }
        }
    };
    if (selectedTime) {
        var scatterSeries = {
            type: "scatter",
            showInLegend: false,
            enableMouseTracking: false,
            data: [
                {
                    x: selectedTime.getTime(),
                    y: 0,
                    color: "purple",
                    marker: {
                        radius: 6
                    }
                }, 
            ]
        };
        plotConfig.series.push(scatterSeries);
    }
    var tempAlarmSeries = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var alarmLimit = _step.value;
            var alarmLimitId = new AlarmId(alarmLimit.id).alarmUUID;
            var matchingLine = tempAlarmSeries.filter(function(alarm) {
                return new AlarmId(alarm.id).alarmUUID === alarmLimitId;
            })[0];
            var line = {
                visible: true,
                animation: false,
                type: "line",
                name: alarmLimit.label.text,
                id: alarmLimit.id,
                data: [
                    {
                        x: alarmLimit.from,
                        y: alarmLimit.value
                    },
                    {
                        x: alarmLimit.to,
                        y: alarmLimit.value
                    }, 
                ],
                color: alarmLimit.color,
                dashStyle: "Dash",
                cursor: "false",
                linkedTo: matchingLine ? matchingLine.id : undefined,
                states: {
                    hover: {
                        lineWidthPlus: 0
                    }
                },
                enableMouseTracking: false
            };
            tempAlarmSeries.push(line);
            // @ts-ignore
            plotConfig.series.push(line);
        };
        for(var _iterator = alarmLimits[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Vertical annotations come in two variants: Point-in-time, or a time-range.
    // Point-in-time annotations are shown as labels.
    // Time-range annotations are shown as rectangular boxes.
    var verticalAnnotationsLabels = [];
    if (legends.showAnnotations) {
        var verticalAnnotations = sensors.flatMap(function(param) {
            var verAnnotations = param.verticalAnnotations;
            return verAnnotations !== null && verAnnotations !== void 0 ? verAnnotations : [];
        });
        verticalAnnotationsLabels = verticalAnnotations.filter(function(x) {
            return x.timestampEnd === null;
        }).map(function(verAnno) {
            var ref;
            var ref1;
            // We try to find the y-Value closest matching the sensor data
            // And if it fails, meaning there is no sensor data, we set the label at 10 as a dummy value
            var data = (ref1 = (ref = plotConfig === null || plotConfig === void 0 ? void 0 : plotConfig.series[0]) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : [];
            var x = new Date(verAnno.timestamp).getTime();
            var y = 10;
            var estimated = closest(x, data);
            if ((estimated === null || estimated === void 0 ? void 0 : estimated.y) !== undefined && (estimated === null || estimated === void 0 ? void 0 : estimated.y) !== null) {
                y = estimated.y;
            }
            return {
                point: {
                    x: x,
                    y: y,
                    xAxis: 0,
                    yAxis: 0
                },
                y: -25,
                id: verAnno.id,
                text: verAnno.label,
                allowOverlap: true,
                style: {
                    width: "70%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer"
                }
            };
        });
        var data = [];
        verticalAnnotations.filter(function(x) {
            return x.timestampEnd !== null;
        }).forEach(function(x) {
            data.push({
                x: new Date(x.timestamp).getTime(),
                x2: new Date(x.timestampEnd).getTime(),
                y: 1,
                custom: x,
                dataLabels: {
                    format: "{point.name}",
                    enabled: true,
                    style: {
                        width: "70%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: "pointer",
                        fontWeight: "normal",
                        fontSize: "11px"
                    }
                },
                events: {
                    click: function(event) {
                        var custom = event.point.custom;
                        if (onAnnotationClicked) {
                            onAnnotationClicked(custom);
                        }
                    }
                },
                name: x.label,
                color: "#404040"
            });
        });
        var annotationRangesSeries = {
            showInLegend: false,
            data: data,
            animation: false,
            type: "xrange",
            name: "Annotations",
            cursor: "pointer",
            color: "#404040",
            borderColor: "#404040",
            tooltip: {
                pointFormatter: function pointFormatter() {
                    return "".concat(this.name);
                },
                headerFormat: ""
            }
        };
        if (data.length) {
            var ref22;
            (ref22 = plotConfig.series) === null || ref22 === void 0 ? void 0 : ref22.push(annotationRangesSeries);
        }
    }
    plotConfig.annotations = [
        {
            labels: verticalAnnotationsLabels,
            animation: false
        }, 
    ];
    return plotConfig;
};
/**
 * Finds the neddle or the closest neighbor in the haystack.
 * Returns undefined, if haystack is empty
 * NOTE: Haystack must be sorted in ascending order.
 */ function closest(needle, haystack) {
    var ref, ref1;
    var closestRightIndex = haystack.findIndex(function(point) {
        return point.x >= needle;
    });
    var closestLeftIndex = closestRightIndex - 1;
    var rightValue = (ref = haystack[closestRightIndex]) === null || ref === void 0 ? void 0 : ref.x;
    var rightDistance = rightValue === undefined ? Number.MAX_VALUE : needle - rightValue;
    var leftValue = (ref1 = haystack[closestLeftIndex]) === null || ref1 === void 0 ? void 0 : ref1.x;
    var leftDistance = leftValue === undefined ? Number.MAX_VALUE : needle - leftValue;
    var shortestDistanceIdx = Math.abs(leftDistance) < Math.abs(rightDistance) ? closestLeftIndex : closestRightIndex;
    return haystack[shortestDistanceIdx];
}
/* harmony default export */ var data_config = (getConfig);


/***/ }),

/***/ 51169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nl": function() { return /* binding */ memoizedFiltering; },
/* harmony export */   "p_": function() { return /* binding */ movingAverage; }
/* harmony export */ });
/* unused harmony export midRangeFilter */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99758);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67997);
/* harmony import */ var lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_memoize__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lru_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29416);
/* harmony import */ var lru_cache__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lru_cache__WEBPACK_IMPORTED_MODULE_1__);






// NOTE: Since JS doesn't expose memory addresses, we cannot easily determine if
// an object has changed. However, we can store such unique items in a WeakMap
// to implement such functionality. The id is incremented everytime the object's
// reference changes. This is useful for caching purposes, e.g. in
// memoizedFiltering below.
var id = function() {
    var currentId = 0;
    var map = new WeakMap();
    return function(object) {
        if (!map.has(object)) {
            map.set(object, ++currentId);
        }
        return "".concat(map.get(object));
    };
}();
var memoizedFiltering = lodash_memoize__WEBPACK_IMPORTED_MODULE_0___default()(function(points, filters) {
    return filters.reduce(function(filteredPoints, filter) {
        return filter(filteredPoints);
    }, points);
}, function(points, filters) {
    var cacheIdentifiers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _points = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(points, 1), point = _points[0];
    return [
        id(point || {}),
        filters.length,
        Object.entries(cacheIdentifiers).map(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            return "".concat(key, ":").concat(value);
        }).join("-"), 
    ].join("|");
});
var lru = new (lru_cache__WEBPACK_IMPORTED_MODULE_1___default())({
    max: 50
});
// NOTE: memoize expects a different interface than what lru-cache provides.
var defaultSetter = lru.set;
// @ts-ignore
lru.set = function(key, value, maxAge) {
    return defaultSetter.apply(this, [
        key,
        value,
        maxAge
    ]) && this;
};
// @ts-ignore
memoizedFiltering.cache = lru;
var midRangeFilter = function(size) {
    return function(range) {
        var globalMax = range.reduce(function(max, param) {
            var y = param.y;
            return Math.max(max, y || 0);
        }, 1);
        return range.reduce(function(averaged, value, index) {
            var _Math, _Math1;
            if (typeof value.y !== "number") {
                averaged.push(value);
                return averaged;
            }
            var start = Math.max(0, index - size);
            var end = Math.min(range.length, index + size + 1);
            var window = range.slice(start, end).filter(function(param) {
                var y = param.y;
                return typeof y === "number";
            }).map(function(param) {
                var y = param.y;
                return y || 0;
            });
            var min = (_Math = Math).min.apply(_Math, _to_consumable_array(window));
            var max = (_Math1 = Math).max.apply(_Math1, _to_consumable_array(window));
            var definiteValue = value.y || 0;
            var midrange = (min + max) / 2;
            var significant = Math.abs(midrange - definiteValue) / globalMax > 0.2;
            averaged.push(_object_spread_props(_object_spread({}, value), {
                y: significant ? value.y : midrange
            }));
            return averaged;
        }, []);
    };
};
var movingAverage = function(size) {
    return function(range) {
        return range.reduce(function(averaged, value, index) {
            if (typeof value.y !== "number") {
                averaged.push(value);
                return averaged;
            }
            var start = Math.max(0, index - size);
            var end = Math.min(range.length, index + size + 1);
            var window = range.slice(start, end).filter(function(param) {
                var y = param.y;
                return typeof y === "number";
            }).map(function(param) {
                var y = param.y;
                return y || 0;
            });
            averaged.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, value), {
                y: window.reduce(function(sum, value) {
                    return sum + value;
                }, 0) / window.length
            }));
            return averaged;
        }, []);
    };
}; // NOTE: Mixing filters into the second iteration of the samples becomes fairly
 // complex, because we may potentially have a window that spans into the future,
 // to a sample point that is yet to be processed. We could introduce a lag that
 // is equivalent to half the window size, but that shifts everything. The
 // following commented functions allow to be run in this fashion, however, the
 // lag must be determined by the caller (and range represent that shift).
 //
 // The caller would do something like the following (it is not tested, read it as pseudo code):
 // const composers = [
 //   voidProcessor({ average: isMeasurement, now }),
 //   filters.reduce((processor, filter) => {
 //     return (storedPoints, point, index, points) => {
 //       const processedPoints = processor(point, index, points) as HighchartsPoint[];
 //       const processedPointIndex = processedPoints.findIndex((point) => typeof point.y === 'number');
 //       return processedPoints.splice(processedPointIndex, 1, filter(processedPoints[processedPointIndex], index - Math.ceil(windowSize / 2), storedPoints));
 //     };
 //   }, sampleProcessor({ scale, average: isMeasurement, perPointSpan })),
 //   varianceProcessor({ isMeasurement }),
 // ];
 //
 // The smart thing about it, is that we can do all processing steps in linear
 // time (as I think maybe the filters we wish to use can utilize the cumsum
 // structure) :pog:
 // export const midRangeFilter = (size: number) => <T extends { y: number | null }>(point: T, index: number, range: T[]) => {
 //   const globalMax = range.reduce((max, { y }) => Math.max(max, y || 0), 1);
 //   return range.reduce<T[]>((averaged, value, index) => {
 //     const start = Math.max(0, index - size);
 //     const end = Math.min(range.length, index + size + 1);
 //     const window = range.slice(start, end).map(({ y }) => y || 0);
 //     const min = Math.min(...window);
 //     const max = Math.max(...window);
 //     const definiteValue = value.y || 0;
 //     const midrange = (min + max) / 2;
 //     const significant = Math.abs(midrange - definiteValue) / globalMax > 0.2;
 //     averaged.push({
 //       ...value,
 //       y: significant ? value.y : midrange,
 //     });
 //     return averaged;
 //   }, []);
 // };
 // export const movingAverage = (size: number) => <T extends { y: number | null }>(point: T, index: number, range: T[]) => {
 //   return range.reduce<T[]>((averaged, value, index) => {
 //     const start = Math.max(0, index - size);
 //     const end = Math.min(range.length, index + size + 1);
 //     const window = range.slice(start, end).map(({ y }) => y || 0);
 //     averaged.push({
 //       ...value,
 //       y: window.reduce((sum, value) => sum + value, 0) / window.length,
 //     });
 //     return averaged;
 //   }, []);
 // };


/***/ }),

/***/ 80946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48417);
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25955);
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50663);
/* harmony import */ var lodash_partition__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_partition__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61431);
/* harmony import */ var _helpers_manual_process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90527);
/* harmony import */ var _lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84521);
// eslint-disable-next-line max-classes-per-file







var manualProcessConfig = function(param) {
    var data = param.data, refetch = param.refetch, pendingControls = param.pendingControls, selectedControlId = param.selectedControlId, chartHeight = param.chartHeight, theme = param.theme, disableLabels = param.disableLabels, onClickStop = param.onClickStop, onOverrideClick = param.onOverrideClick, setSelectedTime = param.setSelectedTime;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var from = ((ref = data.time) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.timeRange) === null || ref2 === void 0 ? void 0 : ref2.from) ? new Date((ref3 = data.time) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.timeRange) === null || ref5 === void 0 ? void 0 : ref5.from) : new Date();
    var to = ((ref6 = data.time) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.timeRange) === null || ref8 === void 0 ? void 0 : ref8.to) ? new Date((ref9 = data.time) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.timeRange) === null || ref11 === void 0 ? void 0 : ref11.to) : new Date();
    var ref18;
    var stops = (ref18 = (ref12 = data.time) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.stops) !== null && ref18 !== void 0 ? ref18 : [];
    var ref19;
    var batches = (ref19 = (ref14 = data.time) === null || ref14 === void 0 ? void 0 : (ref15 = ref14[0]) === null || ref15 === void 0 ? void 0 : ref15.batches) !== null && ref19 !== void 0 ? ref19 : [];
    var ref20;
    var dataOverrides = (ref20 = (ref16 = data.time) === null || ref16 === void 0 ? void 0 : (ref17 = ref16[0]) === null || ref17 === void 0 ? void 0 : ref17.dataOverrides) !== null && ref20 !== void 0 ? ref20 : [];
    return {
        title: false,
        exporting: {
            enabled: false
        },
        chart: {
            resetZoomButton: {
                theme: {
                    display: "none"
                }
            },
            zoomType: "x",
            height: chartHeight + "px",
            events: {
                click: function click(e) {
                    var ref, ref1;
                    if (setSelectedTime && (e === null || e === void 0 ? void 0 : (ref = e.xAxis) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.value)) {
                        var ref2, ref3;
                        setSelectedTime(new Date(e === null || e === void 0 ? void 0 : (ref2 = e.xAxis) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.value));
                    }
                },
                selection: function selection(e) {
                    if (refetch) {
                        e.preventDefault();
                        refetch(new Date(e.xAxis[0].min), new Date(e.xAxis[0].max), true);
                    }
                }
            }
        },
        series: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getSerie(from, to, stops, dataOverrides)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getPendingControlsSeries(pendingControls !== null && pendingControls !== void 0 ? pendingControls : [], selectedControlId !== null && selectedControlId !== void 0 ? selectedControlId : null))),
        xAxis: {
            type: "datetime",
            dateTimeLabelFormats: {
                month: "%e. %b",
                year: "%b"
            },
            plotBands: onClickStop ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getBatchAndStopsPlotBands */ .i0)(batches, [], {
                from: from,
                to: to
            }, theme)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(getClickableStopPlotBands(stops, onClickStop, theme, disableLabels)), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getOverridesPlotBands */ .fb)(dataOverrides, {
                from: from,
                to: to
            }, theme, onOverrideClick))) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getBatchAndStopsPlotBands */ .i0)(batches, stops, {
                from: from,
                to: to
            }, theme, !disableLabels)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getOverridesPlotBands */ .fb)(dataOverrides, {
                from: from,
                to: to
            }, theme, onOverrideClick))),
            minTickInterval: 30..seconds
        },
        yAxis: {
            min: 0,
            max: 2,
            maxPadding: 0.05,
            endOnTick: false,
            labels: {
                enabled: false
            },
            title: {
                text: undefined
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: true
        },
        tooltip: {
            enabled: false
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: false,
                        animation: false
                    }
                }
            },
            area: {
                marker: {
                    radius: 2,
                    enabled: false
                },
                lineWidth: 1,
                states: {
                    hover: {
                        lineWidth: 1
                    }
                },
                threshold: null
            }
        }
    };
};
var getSerie = function(from, to, stops, dataOverrides) {
    var stopTimes = stops.length > 0 ? stops : dataOverrides.filter(function(override) {
        return override.value === 0;
    });
    var samples = (0,_helpers_manual_process__WEBPACK_IMPORTED_MODULE_3__/* .getManualProcessSamples */ .R)(from, to, stopTimes, _constants__WEBPACK_IMPORTED_MODULE_4__/* .SAMPLE_POINTS */ .fd);
    var color = (0,_lib_highcharts_config_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getSerieColor */ .RI)(generated_graphql_schema__WEBPACK_IMPORTED_MODULE_5__/* .SensorType.MANUAL_PROCESS */ .dE.MANUAL_PROCESS, 0);
    var data = samples.map(function(s) {
        return {
            x: new Date(s.timeRange.from).getTime(),
            y: s.data.accValue === 0 ? 0 : 1
        };
    });
    return [
        // serie 0, main data line / area graph
        {
            animation: false,
            type: "area",
            id: "obj.name",
            name: "",
            data: data,
            color: color.color,
            showInLegend: false,
            shared: false,
            zIndex: 5
        }, 
    ];
};
var getClickableStopPlotBands = function(stops, onClick, theme, disableLabels) {
    return stops.map(function(stop) {
        var causeType = stop.stopCause ? stop.stopCause.stopType : "UNREGISTERED_PLOT_BAND";
        return {
            from: stop.timeRange.from ? new Date(stop.timeRange.from).getTime() : null,
            to: stop.timeRange.to ? new Date(stop.timeRange.to).getTime() : null,
            color: theme.blackbird.stops[causeType].color.normal,
            id: stop.timeRange.from,
            label: !disableLabels && {
                useHTML: true,
                text: stop.stopCause ? stop.stopCause.name : undefined,
                style: {
                    width: "100px",
                    textOverflow: "ellipsis"
                },
                rotation: 90,
                textAlign: "left",
                verticalAlign: "top"
            },
            zIndex: 6,
            events: {
                click: function() {
                    return onClick(stop);
                }
            }
        };
    });
};
var getPendingControlsSeries = function(pendingControls, selectedControlId) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(lodash_partition__WEBPACK_IMPORTED_MODULE_0___default()(pendingControls, function(control) {
        return control.batchControlId === selectedControlId;
    }), 2), selectedControls = ref[0], unselectedControls = ref[1];
    return [
        {
            animation: false,
            type: "scatter",
            id: "unselected-pending-controls",
            name: "",
            showInLegend: false,
            data: unselectedControls.map(function(control) {
                return [
                    new Date(control.timeTriggered).getTime(),
                    0
                ];
            }),
            marker: {
                fillColor: "#FFC107",
                symbol: "triangle",
                radius: 5
            },
            zIndex: 10
        },
        {
            animation: false,
            type: "scatter",
            id: "selected-pending-controls",
            name: "",
            showInLegend: false,
            data: selectedControls.map(function(control) {
                return [
                    new Date(control.timeTriggered).getTime(),
                    0
                ];
            }),
            marker: {
                fillColor: "#ff8f00",
                radius: 8,
                symbol: "triangle"
            },
            zIndex: 10
        }, 
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (manualProcessConfig);


/***/ })

}]);